import Reveal from '@/components/base/Reveal';
import { overviewPoints, overviewStats } from '@/mocks/indexNav';

export default function StatsOverview() {
  return (
    <section id="overview" className="w-full bg-primary-600 py-14 text-background-50 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8">
            <div className="max-w-2xl">
              <div className="mb-2 flex items-center gap-2 text-accent-300">
                <span className="h-3 w-1 rounded-full bg-accent-400" />
                <span className="font-label text-xs tracking-[0.28em] uppercase">Coverage</span>
              </div>
              <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-[32px]">
                收录总览 · 全收录结构清晰可查
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-background-100/80">
                所有条目统一入目录，更新量、分类数与专题数量实时可见，找料不迷路。
              </p>
            </div>
            <a
              href="#index"
              className="inline-flex items-center gap-2 rounded-md border border-background-50/30 px-4 py-2 text-sm text-background-50 whitespace-nowrap cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-300"
            >
              返回索引
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
          {overviewStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 70}>
              <div className="flex h-full flex-col justify-between rounded-lg border border-background-50/20 bg-primary-700/70 p-5">
                <span className="font-label text-3xl font-semibold text-background-50 md:text-4xl">{stat.value}</span>
                <div className="mt-3">
                  <span className="block text-xs tracking-wide text-accent-200">{stat.label}</span>
                  <span className="mt-0.5 block text-[11px] text-background-100/60">{stat.note}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {overviewPoints.map((point, index) => (
            <Reveal key={point.title} delay={index * 70}>
              <div className="flex h-full items-start gap-3 rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                  <i className={`${point.icon} text-lg`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-background-50">{point.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-background-100/75">{point.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}